import { accessLevelGroups } from '../consts/access-level-groups.constant';
import { UserAccessLevelGroupName } from '../enums/user-access-level-group-name.enum';
import { UserLevel } from 'src/modules/security/enums/user-level.enum';

export const accessLevelBelongToGroup = (
  accessLevelGroupName: UserAccessLevelGroupName | undefined,
  accessLevel: UserLevel | null
): boolean => {
  if (accessLevelGroupName === undefined || !accessLevelGroups.hasOwnProperty(accessLevelGroupName) || accessLevel === null) {
    return false;
  }
  const group = accessLevelGroups[accessLevelGroupName];
  return group.includes(accessLevel);
};
